import React, { Component } from 'react';
import { Space, Row, Col, Typography, message, Table, Tooltip, Tag } from 'antd';
import { AppstoreOutlined, BookOutlined, SearchOutlined } from '@ant-design/icons';
import { connect } from 'react-redux';
import axios from 'axios';
import {
  ModalItem,
  InputItem,
  ButtonItem,
  dineroDisabledMask,
} from '../../../Components/Items';
import debounce from "lodash.debounce";
import moment from 'moment';
import ModalGenerarFacturaVariasRemisiones from '../../Panel/Ventas/FacturarVariasRemisiones/ModalGenerarFacturaVariasRemisiones/ModalGenerarFacturaVariasRemisiones';

const { Text } = Typography;

class FacturarVenta extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchTerm: '',
      ventas: [],
      totalVentas: 0,
      loading: false,
      currentPage: 1,
      pageSize: 10,
      selectedRowKeys: [],
      selectedVentas: [], // NUEVO: almacenar las ventas completas seleccionadas
      modalRemisiones: false,
      subtotal: 0,
      total: 0,
    };

    this.debouncedConsultar = debounce(() => {
      this.consultarVentas();
    }, 500);
  }

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      this.consultarVentas();
    }
    if (this.props.recargarVentas !== prevProps.recargarVentas && this.props.recargarVentas && this.props.visible) {
      this.consultarVentas();
    }
  }

  obtenerPrecioPorId = (insumo) => {
    if (!this.props.precioId) {
      return insumo.precios && insumo.precios.length > 0
        ? insumo.precios[0].precio
        : insumo.costo;
    }

    const precioEncontrado = insumo.precios && insumo.precios.find(
      precio => precio.precioId === this.props.precioId
    );

    return precioEncontrado ? precioEncontrado.precio : insumo.costo;
  };

  consultarVentas = () => {
    this.setState({ loading: true });

    const { searchTerm, currentPage, pageSize } = this.state;

    axios
      .post(
        "puntoVenta/selectVentasFacturarPaginado",
        {
          empresaId: this.props.empresaId,
          sesionId: this.props.sesionId,
          proyectoId: this.props.proyectoId,
          query: searchTerm,
          skip: (currentPage - 1) * pageSize,
          limit: pageSize
        },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            ventas: res.data.items.map((value) => {
              let numero = ''
              if (value.factura) {
                if (numero !== '') {
                  numero += ' '
                }
                numero += (value.facturaSerie ? value.facturaSerie : 'F') + ' ' + value.facturaNumero
              }
              if (value.facturaGlobal) {
                if (numero !== '') {
                  numero += ' '
                }
                numero += (value.facturaGlobalSerie ? value.facturaGlobalSerie : 'FG') + ' ' + (value.facturaGlobalNumero ? value.facturaGlobalNumero : '')
              }
              if (value.remision) {
                if (numero !== '') {
                  numero += ' '
                }
                numero += (value.remisionSerie ? value.remisionSerie : 'R') + ' ' + value.remisionNumero
              }
              return {
                ...value,
                fechaVenta: value.fechaFactura ? value.fechaFactura : value.fechaRemision,
                numero: numero,
                cliente: (value.cliente.persona ? value.cliente.razonSocial : (value.cliente.nombre + ' ' + value.cliente.apellidoPaterno + ' ' + value.cliente.apellidoMaterno)) + " - " + value.cliente.rfc,
                vendedor: value.vendedor ? (value.vendedor.nombre + " " + (value.vendedor.apellidoPaterno || "") + ' ' + (value.vendedor.apellidoMaterno || "")) : '',
                accion: {
                  _id: value._id,
                  cancelacion: value.cancelacion,
                  dataFactura: !!value.dataFactura,
                  estado: value.estado,
                  estadoCosteo: value.estadoCosteo,
                  servicios: value.servicios,
                  estadoPago: value.estadoPago,
                  facturaGlobal: value.facturaGlobal,
                  sesionId: value.sesionId,
                  cajaId: value.cajaId,
                  factura: value.factura,
                  contado: value.contado,
                  remision: value.remision,
                  cuentasXC: value.cuentasXC,
                  envios: value.envios,
                  flete: value.flete,
                  ventaProgramada: value.ventaProgramada,
                },
              };
            }),
            totalVentas: res.data.total,
            loading: false
          });
        } else {
          message.error("No se encontraron ventas");
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        console.error("Error al consultar ventas:", error);
        message.error("Error al consultar ventas");
        this.setState({ loading: false });
      });
  };

  onSearchChange = (e) => {
    this.setState({ searchTerm: e.target.value, currentPage: 1 }, () => {
      this.debouncedConsultar();
    });
  };

  onTableChange = (pagination) => {
    this.setState(
      {
        currentPage: pagination.current,
        pageSize: pagination.pageSize
      },
      () => {
        this.consultarVentas();
      }
    );
  };

  handleCancel = () => {
    this.setState({
      searchTerm: '',
      ventas: [],
      currentPage: 1,
      selectedRowKeys: [],
      selectedVentas: [], // NUEVO: limpiar ventas seleccionadas
      subtotal: 0,
      total: 0,
    });
    this.props.onCancel();
  };

  handleAddToCart = (product) => {
    this.props.onAddToCart(product);
  };

  handleFacturarVenta = (venta) => {
    this.props.handleFacturarVenta(venta);
  }


  getVentasSeleccionadas = (selectedRowKeys, selectedRows = []) => {
    const { selectedVentas, ventas } = this.state;

    // Crear un mapa de las ventas ya seleccionadas (solo si existen)
    const ventasMap = new Map(
      (selectedVentas || [])
        .filter(v => v && v._id)
        .map(v => [v._id.toString(), v])
    );

    // Agregar nuevas selecciones (solo las válidas)
    (selectedRows || [])
      .filter(venta => venta && venta._id)
      .forEach(venta => {
        ventasMap.set(venta._id.toString(), venta);
      });

    // Buscar en las ventas actuales por si faltan
    (selectedRowKeys || [])
      .filter(id => id)
      .forEach(id => {
        const idStr = id.toString();
        if (!ventasMap.has(idStr)) {
          const ventaEnPaginaActual = (ventas || []).find(
            v => v && v._id && v._id.toString() === idStr
          );
          if (ventaEnPaginaActual) {
            ventasMap.set(idStr, ventaEnPaginaActual);
          }
        }
      });

    // Filtrar solo las ventas que realmente están seleccionadas
    const selectedRowKeysSet = new Set(
      (selectedRowKeys || []).map(id => id && id.toString())
    );

    return Array.from(ventasMap.values()).filter(
      v => v && selectedRowKeysSet.has(v._id.toString())
    );
  };


  abrirModalFacturarVariasRemisiones = () => {
    if (this.state.selectedRowKeys.length === 0) {
      message.warning('Selecciona al menos una venta para generar la factura');
      return;
    }

    let cliente;
    let contado;
    let moneda;
    let proyecto;

    for (const venta of this.state.selectedVentas) {
      if (!venta) continue;

      if (!moneda && !cliente && contado === undefined && !proyecto) {
        moneda = venta.moneda.toString();
        cliente = venta.cliente.toString();
        contado = venta.contado;
        proyecto = venta.proyecto.nombre.toString();
      } else {
        if (moneda !== venta.moneda.toString()) {
          message.warning('Las ventas necesitan ser de la misma moneda');
          return;
        }

        if (cliente !== venta.cliente.toString()) {
          message.warning('Las ventas necesitan ser del mismo cliente');
          return;
        }

        if (contado !== venta.contado) {
          message.warning('Las ventas necesitan ser todas de contado o todas de crédito sin pagos');
          return;
        }

        if (proyecto !== venta.proyecto.nombre.toString()) {
          message.warning('Las ventas necesitan ser del mismo proyecto');
          return;
        }
      }
    }

    // Validar que solo sea moneda nacional (ID hardcodeado como en el código original)

    // Si llegamos aquí, todas las validaciones pasaron
    this.setState({ modalRemisiones: true });
  };

  onFacturaGenerada = () => {
    this.setState({ 
      modalRemisiones: false, 
      selectedRowKeys: [], 
      selectedVentas: [], // NUEVO: limpiar ventas seleccionadas
      subtotal: 0, 
      total: 0 
    });
    this.consultarVentas();
  };

  getProductColumns = () => [
    {
      title: 'Venta',
      dataIndex: 'numero',
      key: 'numero',
      width: "15%",
    },
    {
      title: 'Cliente',
      dataIndex: 'cliente',
      key: 'cliente',
      width: "30%",
    },
    {
      title: 'Fecha',
      dataIndex: 'fechaVenta',
      key: 'fechaVenta',
      render: (value) => moment(value).locale("es").format("L"),
      width: "15%",
    },
    {
      title: 'Total',
      dataIndex: 'totalPagar',
      key: 'totalPagar',
      render: (totalPagar) => (
        <Text strong style={{ color: '#52c41a' }}>
          {dineroDisabledMask(totalPagar)}
        </Text>
      ),
      width: "20%",
    },
    {
      title: 'Acción',
      key: 'action',
      render: (_, record) => {
        if (record.cuentasXC && record.estadoPago === 0) {
          return (
            <Tooltip title="Primero cobre la venta para poder facturar" >
              <Tag color="blue">
                Cobre primero
              </Tag>
            </Tooltip>
          )
        }
        return (
          <ButtonItem
            type="primary"
            icon={<BookOutlined />}
            onClick={() => this.handleFacturarVenta(record)}
            naranja
            lessTime
          >
            Facturar
          </ButtonItem>
        )
      },
      width: "20%",
    }
  ];

  render() {
    const { visible } = this.props;
    const { loading, ventas, currentPage, pageSize, totalVentas, subtotal, total } = this.state;

    return (
      <>
      <ModalItem
        title={
          <Space>
            <AppstoreOutlined style={{ color: '#00b5e2' }} />
            <span>
              Ventas por Facturar
              {(subtotal !== 0 && total !== 0) && 
                ` - Subtotal: ${dineroDisabledMask(subtotal)}  Total: ${dineroDisabledMask(total)}`
              }
            </span>
          </Space>
        }
        visible={visible}
        onCancel={this.handleCancel}
        footer={null}
        width={1200}
        style={{ top: 20 }}
        destroyOnClose={true}
        spinning={loading}
        zIndex={1000}
      >
        <Row gutter={16} style={{ marginBottom: '16px' }}>
          <Col span={24}>
            <InputItem
              prefix={<SearchOutlined />}
              placeholder="Buscar venta..."
              value={this.state.searchTerm}
              onChange={this.onSearchChange}
              size="large"
              allowClear
              autoFocus
            />
          </Col>
        </Row>

        <div style={{ marginBottom: '16px' }}>
          <Text style={{ fontSize: '14px', color: '#666' }}>
            Mostrando {ventas.length} de {totalVentas} ventas
          </Text>
        </div>
        {this.state.selectedRowKeys.length > 1 && (
          <div style={{ marginBottom: 16, textAlign: "right" }}>
            <ButtonItem
              type="primary"
              naranja
              onClick={this.abrirModalFacturarVariasRemisiones}
            >
              Facturar Varias Remisiones
            </ButtonItem>
          </div>
        )}

        <Table
          dataSource={ventas}
          columns={this.getProductColumns()}
          spinning={loading}
          rowKey="_id"
          rowSelection={{
          selectedRowKeys: this.state.selectedRowKeys,
          preserveSelectedRowKeys: true,
          onSelect: (record, selected, selectedRows) => {
            const { selectedRowKeys } = this.state;
            const id = record._id.toString();

            // Clonar la selección actual
            let newSelectedKeys = [...selectedRowKeys];

            if (selected) {
              // VALIDACIONES INMEDIATAS
              const venta = record;
              const primera = selectedRows[0] || venta;

              if (primera && venta) {
                if (primera.moneda.toString() !== venta.moneda.toString()) {
                  message.warning("Las ventas deben ser de la misma moneda");
                  return; //  Bloquea selección
                }
                if (primera.cliente.toString() !== venta.cliente.toString()) {
                  message.warning("Las ventas deben ser del mismo cliente");
                  return;
                }
                if (primera.contado !== venta.contado) {
                  message.warning("Todas deben ser de contado o crédito sin pagos");
                  return;
                }
                if (primera.proyecto.nombre.toString() !== venta.proyecto.nombre.toString()) {
                  message.warning("Las ventas deben ser del mismo proyecto");
                  return;
                }
                if (venta.contado === 2 && (venta.estadoPago !== 0 || (venta.totalPagado && venta.totalPagado !== 0))) {
                  message.warning("Las ventas de crédito no pueden tener pagos");
                  return;
                }
              }

              // Si pasa las validaciones, agregar el id
              newSelectedKeys.push(id);
            } else {
              // Si se deselecciona, quitarlo
              newSelectedKeys = newSelectedKeys.filter(k => k !== id);
            }

            // Actualizar estado con las filas válidas
            const ventasSeleccionadas = this.getVentasSeleccionadas(newSelectedKeys, selectedRows);
            let total = 0;
            let subtotal = 0;
            ventasSeleccionadas.forEach(v => {
              total += v.totalPagar || 0;
              subtotal += v.subtotal || 0;
            });

            this.setState({
              selectedRowKeys: newSelectedKeys,
              selectedVentas: ventasSeleccionadas,
              total,
              subtotal,
            });
          },
        }}

          pagination={{
            current: currentPage,
            pageSize: pageSize,
            total: totalVentas,
            showSizeChanger: true,
            showQuickJumper: true,
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} de ${total} ventas`,
            pageSizeOptions: ['10', '20', '50'],
            showLessItems: true,
            hideOnSinglePage: false,
            simple: false
          }}
          onChange={this.onTableChange}
          scroll={{ y: 400 }}
          locale={{
            emptyText: loading ? 'Cargando ventas...' : 'No se encontraron ventas'
          }}
        />

      </ModalItem>
      <ModalGenerarFacturaVariasRemisiones
        visible={this.state.modalRemisiones}
        zIndex={1001}
        cerrarGenerarFacturaVariasRemisiones={() =>
          this.setState({
            modalRemisiones: false,
            selectedRowKeys: [],
            selectedVentas: [], // NUEVO: limpiar ventas seleccionadas
            subtotal: 0,
            total: 0,
          })
        }
        onFacturaGenerada={this.onFacturaGenerada}
        ventasIds={this.state.selectedRowKeys}
      />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
  };
};

export default connect(mapStateToProps)(FacturarVenta);